import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const DragIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      fill="none"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
    >
      <path
        d="M7 5C8.10457 5 9 4.10457 9 3C9 1.89543 8.10457 1 7 1C5.89543 1 5 1.89543 5 3C5 4.10457 5.89543 5 7 5Z"
        fill={color}
      />
      <path
        d="M7 13.1667C8.10457 13.1667 9 12.2712 9 11.1667C9 10.0621 8.10457 9.16667 7 9.16667C5.89543 9.16667 5 10.0621 5 11.1667C5 12.2712 5.89543 13.1667 7 13.1667Z"
        fill={color}
      />
      <path
        d="M5 19.3333C5 18.1667 5.83333 17.3333 7 17.3333C8.16667 17.3333 9 18.1667 9 19.3333C9 20.5 8.16667 21.3333 7 21.3333C5.83333 21.3333 5 20.5 5 19.3333Z"
        fill={color}
      />
      <path
        d="M15.6667 5C16.7713 5 17.6667 4.10457 17.6667 3C17.6667 1.89543 16.7713 1 15.6667 1C14.5621 1 13.6667 1.89543 13.6667 3C13.6667 4.10457 14.5621 5 15.6667 5Z"
        fill={color}
      />
      <path
        d="M15.6667 13.1667C16.7713 13.1667 17.6667 12.2712 17.6667 11.1667C17.6667 10.0621 16.7713 9.16667 15.6667 9.16667C14.5621 9.16667 13.6667 10.0621 13.6667 11.1667C13.6667 12.2712 14.5621 13.1667 15.6667 13.1667Z"
        fill={color}
      />
      <path
        d="M13.6667 19.3333C13.6667 18.1667 14.5 17.3333 15.6667 17.3333C16.8334 17.3333 17.6667 18.1667 17.6667 19.3333C17.6667 20.5 16.8334 21.3333 15.6667 21.3333C14.5 21.3333 13.6667 20.5 13.6667 19.3333Z"
        fill={color}
      />
    </svg>
  </CircledIcon>
);
